import GCarousel from "./g-carousel";

class ProductRecommendations extends GCarousel {
  constructor() {
    super();
  }

  async connectedCallback() {
    await super.connectedCallback();
    await this.fetchItems();
  }

  async fetchItems() {
    let url = `${window.routes.productRecommendationsUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit${this.recommendationsCount}`;
    const response = await fetch(url);
    const text = await response.text();
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;
    const newSplideList = tempDiv.querySelector(".splide__list");
    if(newSplideList.childElementCount > 0) {
      this.splideList.innerHTML = newSplideList.innerHTML;
    } else {
      this.setAttribute('aria-hidden', true)
    }
    if(this.splide) {
      this.splide.refresh();
    }
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get productId() {
    return this.dataset.productId;
  }

  get recommendationsCount() {
    return Number(this.dataset.recommendationsCount);
  }
}

customElements.define('product-recommendations', ProductRecommendations);